import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  templateUrl: './page-no-access.component.html',
  styleUrls: ['./page-no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageNoAccessComponent {}
